import React from 'react';
import ProvenanceChip from './ProvenanceChip.jsx';
import { currentPeriodProofView } from './current-period-proof.js';

export default function CurrentPeriodProofBadge({ label, found, proof = null }) {
  const view = currentPeriodProofView({ label, found, proof });

  return (
    <div
      data-testid="current-period-proof"
      data-current-period-label={view.label}
      data-current-period-detail={view.detail ?? ''}
      data-current-period-index={proof?.index ?? -1}
      className="inline-flex max-w-full flex-wrap items-center gap-2 rounded-sm border border-border bg-surface-el/70 px-2 py-1 text-[0.72rem] text-text-muted"
    >
      <span className="font-semibold uppercase tracking-[0.08em] text-text-dim">Current period</span>
      <span className="font-mono text-text">{view.label}</span>
      {view.detail && <span className="font-mono text-[0.66rem] text-text-dim">{view.detail}</span>}
      <ProvenanceChip kind={view.chipKind} tooltip={view.tooltip} compact />
      <span className="font-mono text-[0.66rem] uppercase tracking-[0.05em]">{view.posture}</span>
    </div>
  );
}
